import { call, put, select } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { logger } from 'utils/logger';
import { selectMediaDevicePermissions } from 'features/user-media/userMediaSlice';
import { PermissionStatus } from 'features/user-media/types';

export function* unmuteVideoSaga() {
  const canBroadcastVideo: boolean = yield call(hasPermissionsSaga, PermissionTypes.broadcastVideo);

  if (!canBroadcastVideo) {
    logger.remote().warn('Tried to unmute video without broadcast permission');
    return;
  }

  const camPermissions: PermissionStatus = yield select(selectMediaDevicePermissions, 'videoinput');
  if (camPermissions !== 'granted') {
    logger.remote().warn('Tried to unmute video without media device permission');
    return;
  }

  yield put(interactionTriggered('unmuteVideo'));
  yield call(RTCClient.publishingFeed.startVideoBroadcasting);
}
